module.exports = __webpack_public_path__ + "static/media/sunLogo.f4b38bcc.png";